/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

/**
 * Pitch Deck Version Registry
 * ────────────────────────────
 * Add new content versions here. The InvestorPitchPage reads from this registry
 * and lets you switch between versions via the UI.
 *
 * To add a new version:
 *   1. Create a new file: pitchDeckContent_v3_yourLabel.js
 *   2. Add an entry below with a unique key
 *   3. That's it — it'll appear in the version switcher
 */
import v1 from "./pitchDeckContent_v1_original";
import v2 from "./pitchDeckContent_v2_direct";
import v3 from "./pitchDeckContent_v3_emerson";
import v4 from "./pitchDeckContent_v4_partners";

const versions = {
  v1: {
    key: "v1",
    label: "v1 — Original",
    description: "Initial pitch deck content (from PDF)",
    data: v1,
  },
  v2: {
    key: "v2",
    label: "v2 — Direct & grounded",
    description: "Removed buzzwords, hype, marketing-speak. Plain language, specific claims.",
    data: v2,
  },
  v3: {
    key: "v3",
    label: "v3 — Emerson",
    description: "Emerson-style pitch deck content.",
    data: v3,
  },
  v4: {
    key: "v4",
    label: "v4 — Partner Prospectus",
    description: "Broker and institutional partner version. Compliance-first, B2B framing.",
    data: v4,
  },
};

export const DEFAULT_VERSION = "v3";

export default versions;
